const o = (t = 16) => parseInt(
  Math.ceil(Math.random() * Date.now()).toPrecision(t).toString().replace(".", "")
), a = (t) => Array(t).fill(0).map(() => Math.floor(Math.random() * 16).toString(16)).join("");
export {
  a as generateRandomHex,
  o as uniqueId
};
//# sourceMappingURL=UniqIdUtils.js.map
